export const emptyMouseEventsObject = {
	leftClickEvent: () => null,
	rightClickEvent: () => null,
	bothClickEvent: () => null,
	leftReleaseEvent: () => null,
	rightReleaseEvent: () => null,
	hoverStartEvent: () => null,
	dragArray: null,
	rightClickDragValue: null
};
